import { seoLinks, absoluteUrl, ogImage } from "@/lib/seo";
import { createFileRoute } from "@tanstack/react-router";

import { CtaBand, PageHero, Prose } from "../components/site/Page";
import { SchoolYearDates } from "../components/site/SchoolYearDates";
import { SchoolYearLegacy } from "@/components/site/SchoolYearLegacy";
import { schoolTermsQuery } from "@/lib/school-calendar-query";
import { safeLoader } from "@/lib/safe-loader";


const title = "Läsårstider 2026–2027 | Swedish International School";
const description =
  "Terminstider, lov och röda dagar för skola, förskola och fritids vid Swedish International School Estepona – Marbella.";

export const Route = createFileRoute("/lasarstider")({
  head: () => ({
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: "article" },
      { name: "twitter:card", content: "summary_large_image" },
      { property: "og:url", content: absoluteUrl("/lasarstider") },
      { property: "og:locale", content: "sv_SE" },
      ...ogImage(),
    ],
    links: seoLinks("/lasarstider"),
  }),
  loader: ({ context }) => safeLoader("sv.school-terms", () => context.queryClient.ensureQueryData(schoolTermsQuery("sv")), { terms: [], fetchedAt: null }),
  component: Lasarstider,
});

function Lasarstider() {
  const terms = Route.useLoaderData().terms;

  return (
    <>
      <PageHero
        eyebrow="Kalender"
        title="Läsårstider"
        intro="Nedan datum och lov gäller för skola, förskola och fritids. Vid lov och helgdagar är skola, förskola och fritids stängt."
      />

      <SchoolYearDates terms={terms} />

      <SchoolYearLegacy />


      <Prose>
        <h2>Så är läsåret upplagt</h2>
        <p>
          Läsåret är indelat i en hösttermin och en vårtermin, med lov och helgdagar som följer både
          svensk skoltradition och lokala helgdagar i Andalusien. Datumen ovan gäller skola, förskola
          och fritids, och uppdateras när skolan fastställer kalendern för kommande läsår.
        </p>

        <h2>Att börja mitt i terminen</h2>
        <p>
          Ansökningar tas emot löpande under hela läsåret. Vid start mitt i en termin går vi igenom
          var eleven befinner sig i kursplanen och planerar introduktionen tillsammans med er. I{" "}
          <a className="text-primary link-quiet" href="/ansokan">ansökan</a> väljer ni vilken
          termin ni önskar börja, och startdatumet sätts då till terminens första skoldag.
        </p>

        <h2>Ledighet och frånvaro</h2>
        <p>
          Anmäl sjukfrånvaro till skolan på morgonen. Behöver eleven ledigt utanför loven ansöker ni
          om det hos klassläraren i god tid, så att arbete kan planeras framåt. Vi rekommenderar att
          längre resor läggs på loven eftersom mycket av undervisningen bygger på det gemensamma
          arbetet i klassrummet.
        </p>

        <h2>Frågor om kalendern</h2>
        <p>
          Är något datum oklart eller behöver ni planera en flytt efter skolkalendern? Mejla{" "}
          <a className="text-primary link-quiet" href="mailto:info@sweintschool.com">info@sweintschool.com</a>{" "}
          så hjälper vi till. Praktiska tips inför flytten finns i vår{" "}
          <a className="text-primary link-quiet" href="/guider">guidesamling</a>.
        </p>
      </Prose>

      <CtaBand />
      <div className="h-20" />
    </>
  );
}
